module.exports = __webpack_public_path__ + "static/media/listening_icon.00679fe3.svg";